import {post, get, requestBlob} from 'sdk';
import {BASE_URL} from 'appConstants';

export const uploadFile = (url, {formData, local}) => {
  // When uploading to S3 we don't pass auth headers and
  // Query String Parameters not allowed on POST requests.
  if (!local) {
    return post(url, formData, {}, true);
  }

  return post(url, formData);
};

export const getCsvExport = ({identifier}) => {
  const url = `${BASE_URL}/v1/files/csv-exports/${identifier}/`;

  return get(url);
};

export const getExcelExport = ({identifier}) => {
  const url = `${BASE_URL}/v1/files/excel-exports/${identifier}/`;

  return get(url);
};

export const getExcelExportAsBlob = ({identifier}) => {
  const url = `${BASE_URL}/v1/files/excel-exports/${identifier}/`;

  return requestBlob(url);
};
